import React from 'react';

import BlackTick from './tick-black.svg';

const BlackTickIcon = props => <img {...props} src={BlackTick} alt="" style={{ marginTop: '2px' }} />;

export default BlackTickIcon;
